import styles from "./expenses.module.css";
import { useTripInfo } from "../context";
import { useState } from "react";
import {API_URL} from '../utils/fatch';


export function DeleteExpense(props) {
    const { currentTripId } = useTripInfo();
    const [error, setError] = useState(null);

    const handleDeleteExpense = async (e, expenseId) => {
        e.preventDefault();


        try {
            const response = await fetch(`${API_URL}/expenses/${expenseId}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            if (response.ok) {

                props.setVisibleDeleteModal({ state: false, id: null, name: '' });
                props.setExpensesDemo(props.expensesDemo.filter(expense => expense.id !== expenseId));
            } else {
                console.error('Error deleting expense:', response.statusText);
            }

        } catch (error) {
            console.error("Error deleting expense:", error);
        }
    }
    const handleDeleteAllExpenses = async (e) => {
        e.preventDefault();
      
        try {
            const response = await fetch(`${API_URL}/allExpenses/`, {
                method: 'DELETE',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                 body: JSON.stringify({ tripId: currentTripId})
            });
               const data = await response.json();
            
            if (response.ok) {
             


                props.setVisibleDeleteAll(false);
                    props.setExpensesDemo([]);
                    setError(null);
            } else {
               setError(data.message || 'Error deleting all expenses');
                
            }

        } catch (error) {
            console.error("Error deleting expense:", error);
            setError(`Error deleting all expenses: ${error.message}`);
        }
    }

    return (




        <form className={styles.modalContent} >
            {props.goal === 'allExpenses' && <h3 className="text-2xl font-bold text-gray-800 mb-4">Are you sure you want to delete all expenses ?</h3>}
            {props.goal === 'oneExpense' && <h3 className="text-2xl font-bold text-gray-800 mb-4">Are you sure you want to delete &apos;{props.visibleDeleteModal.name}&apos; ?</h3>}
            <p className="text-gray-600">This action cannot be undone.</p>
            <hr className="my-4 border-gray-200" />
            <div className="flex justify-end space-x-2">
                {props.goal === 'oneExpense' && <>
                    <button className={`${styles.cancelDeleteButton}`} onClick={(e) => { e.preventDefault(); props.setVisibleDeleteModal({ state: false, id: null, name: '' }) }}>
                        Cancel
                    </button>
                    <button className={`${styles.confirmDeleteButton}`} onClick={(e) => handleDeleteExpense(e, props.visibleDeleteModal.id)}>
                        Delete
                    </button>
                </>
                }

                {props.goal === 'allExpenses' && <>
                    <button className={`${styles.cancelDeleteButton}`} onClick={(e) => { e.preventDefault(); props.setVisibleDeleteAll(false) }}>
                        Cancel
                    </button>
                    <button className={`${styles.confirmDeleteButton}`} onClick={(e) => handleDeleteAllExpenses(e)}>
                        Delete
                    </button>

                </>
                }
                
            </div>
            <p style={{color: 'red'}}>{error}</p>
        </form>

    );
}
